import { MailingListListLayout } from '../../features/mailinglist/navigation/MailingListListLayout';

import type { NavItem } from './DashboardNavItems';

export const dashboardNavRenderers: Record<
  string,
  React.ComponentType<{ item: NavItem }>
> = {
  mailinglist: MailingListListLayout,
};
